import { CARD_API_ENDPOINT } from '@/config/consts'
import { useQuery } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { createSmartGet } from './useAuthenticatedMutation'

export interface TelegramNotificationStatus {
  active: boolean
  userAddress: string
}

interface TelegramNotificationStatusResponse {
  data?: TelegramNotificationStatus
}

export function useTelegramNotificationStatus() {
  const { address } = useAccount()
  const url = `${CARD_API_ENDPOINT}/v1/vendor/cards/users/telegram-notifications/status`

  const { data, isLoading, error } = useQuery<TelegramNotificationStatusResponse>({
    queryKey: ['telegram-notification-status', address],
    queryFn: () => createSmartGet(url)(),
    enabled: !!address,
    retry: false,
    staleTime: 60_000,
  })

  const status = data?.data

  return {
    active: status?.active ?? false,
    userAddress: status?.userAddress,
    isLoading,
    error,
  }
}
